import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatDate'
})
export class FormatDatePipe implements PipeTransform {

  transform(date: string): string {
    const dateSplitValue = date.split('T');
    const dateSplit = dateSplitValue[0].split('-');
    const dateReorder = `${dateSplit[2]}-${dateSplit[1]}-${dateSplit[0]}`;
    const timeSplit = dateSplitValue[1].split(':');
    const time = timeSplit.splice(0, 2).join(':');

    return `${dateReorder} ${time}`;
  }

}
